import React, { useState } from 'react'
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import StarBorder from "@mui/icons-material/StarBorder";
import Collapse from "@mui/material/Collapse";
import SearchIcon from '@mui/icons-material/Search';
//import { useNavigate } from "react-router-dom";
function MenuSearch({ handleNavigation }) {
   const [openRpt, setOpenRpt] = useState(false);
    const handleClickRpt = () => {
      setOpenRpt(!openRpt);
    };

   // const navigate = useNavigate(); 

  return (
   
    <List sx={{ bgcolor: "background.paper" }} component="nav">
    <ListItemButton onClick={handleClickRpt}>
      <ListItemIcon>
        <SearchIcon style={{ color: "DodgerBlue" }} />
      </ListItemIcon>
      <ListItemText primary="Search" sx={{color: "DodgerBlue"}}/>
      {openRpt ? (
        <ExpandLess style={{ color: "red" }} />
      ) : (
        <ExpandMore style={{ color: "DodgerBlue" }} />
      )}
    </ListItemButton>
    <Collapse in={openRpt} timeout="auto" unmountOnExit>
      <List component="div" disablePadding sx={{color: "DodgerBlue"}}>
       
       
        <ListItemButton
          sx={{ pl: 4 }}
         /// onClick={() => navigate("poreport")}
         onClick={() => handleNavigation("posearch")}
         
        >
          <ListItemIcon>
            <StarBorder style={{ color: "DodgerBlue" }} />
          </ListItemIcon>
          <ListItemText primary="Search By PO" />
        </ListItemButton>

        
        <ListItemButton
          sx={{ pl: 4 }}
         /// onClick={() => navigate("poreport")}
         onClick={() => handleNavigation("indentsearch")}
         
        >
          <ListItemIcon>
            <StarBorder style={{ color: "DodgerBlue" }} />
          </ListItemIcon>
          <ListItemText primary="Search By Indent" />
        </ListItemButton> 

        <ListItemButton
          sx={{ pl: 4 }}
         /// onClick={() => navigate("poreport")}
         onClick={() => handleNavigation("indentsearchbyname")}
         
        >
          <ListItemIcon>
            <StarBorder style={{ color: "DodgerBlue" }} />
          </ListItemIcon>
          <ListItemText primary="Search By Item Name" />
        </ListItemButton> 

      </List>
    </Collapse>
  </List>

  )
}

export default MenuSearch